import { render, staticRenderFns } from "./PublicUpLoader.vue?vue&type=template&id=3cfff4e6&scoped=true&"
import script from "./PublicUpLoader.vue?vue&type=script&lang=js&"
export * from "./PublicUpLoader.vue?vue&type=script&lang=js&"
import style0 from "./PublicUpLoader.vue?vue&type=style&index=0&id=3cfff4e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfff4e6",
  null
  
)

export default component.exports